// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./store/index";
import router from "./router";
import VueAnalytics from "vue-analytics";
import ElementUI from "element-ui";
import "es6-promise/auto";
import "element-ui/lib/theme-chalk/index.css";
import moment from "moment";
import VueI18n from "vue-i18n";
import './components/common/font/font.css'
import Animate from "animate.css"
import * as VueGoogleMaps from 'vue2-google-maps'
import ApolloClient from 'apollo-boost' 
import VueApollo from 'vue-apollo'
import axios from 'axios';
import { getQuery,getMutate } from '@/module/handleGql.js'
import defaultImg from '@/assets/default.png'
Vue.prototype.axios = axios;
Vue.prototype.getQuery = getQuery;
Vue.prototype.getMutate = getMutate;
Vue.prototype.$defaultImg = defaultImg;
Vue.use(VueApollo)
const apolloClient = new ApolloClient({
	// uri:'/api/graphql'
	uri:'http://18.163.16.253:80/graphql'
	// uri:'http://192.168.50.152:8888/graphql'
})

const apolloProvider = new VueApollo({
    defaultClient: apolloClient
})
//111

Vue.prototype.$moment = moment;
Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.use(Animate)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDh8V_GcV2v4JkXzl-kSY4Yl1csoYZDfKQ',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // If you want to set the version, you can do so:
    // v: '3.26',
  },

  // If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  autobindAllEvents: false,

  // If you want to manually install components, e.g.
  // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then disable the following:
  installComponents: true,
})
Vue.config.productionTip = false;


// init GA
if (process.env.GA) {
  Vue.use(VueAnalytics, {
    id: process.env.GA,
    disableScriptLoader: true,
    router,
    autoTracking: {
      pageviewOnLoad: false
    }
  });
}

const i18n = new VueI18n({
  locale: "zh",
  messages: {
    zh: require("./components/common/lang/zh-base"),
    en: require("./components/common/lang/en-base")
  },
  silentTranslationWarn: true
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title和description */
  if (to.meta.title) {
    document.title = to.meta.title;
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", to.meta.description);
    document
      .querySelector('meta[name="Keywords"]')
      .setAttribute("content", to.meta.keywords);
  }
  next();
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
	//
	apolloProvider,
	//
  components: { App },
  template: "<App/>",
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  }
});
